'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import Button from '@eversports/klimt-primitives/Button';
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuItem, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@eversports/klimt-primitives/DropdownMenu';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { FILTER_DATA, FILTER_OPTIONS_TRANSLATION_MAPPING } from '../Filters.constants';
import { type FILTER_OPTIONS, FILTER_TYPE } from '../Filters.types';
import type { UpdateFiltersProps } from './AdditionalFilters';
const ALL_FILTERS_VALUE = 'all';
interface Props {
  filterType: FILTER_TYPE;
  selectedFilters: Array<string>;
  updateFilters: (values: UpdateFiltersProps) => () => void;
  resetFilter: (type: FILTER_TYPE) => () => void;
  handleApply: () => void;
  undoFilterSelection: () => void;
}
const FilterDropdown = t0 => {
  const $ = _c(82);
  const {
    filterType,
    selectedFilters,
    updateFilters,
    resetFilter,
    handleApply,
    undoFilterSelection
  } = t0;
  const t = useTranslations("discover-sport-city");
  const [isOpen, setIsOpen] = useState(false);
  const {
    options,
    deskTopHeaderTranslationKey,
    icon: Icon
  } = FILTER_DATA[filterType];
  const searchParams = useSearchParams();
  let T0;
  let T1;
  let T2;
  let handleClick;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== Icon || $[1] !== deskTopHeaderTranslationKey || $[2] !== filterType || $[3] !== handleApply || $[4] !== isOpen || $[5] !== searchParams || $[6] !== t || $[7] !== undoFilterSelection) {
    const params = new URLSearchParams(searchParams.toString());
    const activeFilters = params.getAll(filterType);
    const hasActiveFilters = activeFilters.length > 0;
    let t9;
    if ($[20] !== t) {
      t9 = option => t(FILTER_OPTIONS_TRANSLATION_MAPPING[option as FILTER_OPTIONS]);
      $[20] = t;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    const activeFiltersTranslations = activeFilters.map(t9);
    let t10;
    if ($[22] !== isOpen || $[23] !== undoFilterSelection) {
      t10 = () => {
        setIsOpen(!isOpen);
        undoFilterSelection();
      };
      $[22] = isOpen;
      $[23] = undoFilterSelection;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    const toggleDropdown = t10;
    let t11;
    if ($[25] !== handleApply || $[26] !== toggleDropdown) {
      t11 = () => {
        handleApply();
        toggleDropdown();
      };
      $[25] = handleApply;
      $[26] = toggleDropdown;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    handleClick = t11;
    T2 = DropdownMenu;
    t7 = isOpen;
    t8 = toggleDropdown;
    T1 = DropdownMenuTrigger;
    t5 = true;
    t6 = "hidden items-center gap-1 sm:flex";
    T0 = Button;
    t1 = hasActiveFilters ? "tertiary-selected" : "tertiary";
    t2 = "sm";
    const t12 = hasActiveFilters ? "text-text-brand-primary" : "text-text-secondary";
    let t13;
    if ($[28] !== t12) {
      t13 = cn("size-2", t12);
      $[28] = t12;
      $[29] = t13;
    } else {
      t13 = $[29];
    }
    if ($[30] !== Icon || $[31] !== t13) {
      t3 = <Icon className={t13} aria-hidden={true} />;
      $[30] = Icon;
      $[31] = t13;
      $[32] = t3;
    } else {
      t3 = $[32];
    }
    t4 = hasActiveFilters ? activeFiltersTranslations.join(", ") : t(deskTopHeaderTranslationKey);
    $[0] = Icon;
    $[1] = deskTopHeaderTranslationKey;
    $[2] = filterType;
    $[3] = handleApply;
    $[4] = isOpen;
    $[5] = searchParams;
    $[6] = t;
    $[7] = undoFilterSelection;
    $[8] = T0;
    $[9] = T1;
    $[10] = T2;
    $[11] = handleClick;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    T0 = $[8];
    T1 = $[9];
    T2 = $[10];
    handleClick = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
  }
  let t9;
  if ($[33] !== T0 || $[34] !== t1 || $[35] !== t2 || $[36] !== t3 || $[37] !== t4) {
    t9 = <T0 variant={t1} size={t2}>{t3}{t4}</T0>;
    $[33] = T0;
    $[34] = t1;
    $[35] = t2;
    $[36] = t3;
    $[37] = t4;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  let t10;
  if ($[39] !== T1 || $[40] !== t5 || $[41] !== t6 || $[42] !== t9) {
    t10 = <T1 asChild={t5} className={t6}>{t9}</T1>;
    $[39] = T1;
    $[40] = t5;
    $[41] = t6;
    $[42] = t9;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  const t11 = !selectedFilters.length ? ALL_FILTERS_VALUE : "";
  let t12;
  if ($[44] !== filterType || $[45] !== resetFilter) {
    t12 = resetFilter(filterType);
    $[44] = filterType;
    $[45] = resetFilter;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  let t13;
  if ($[47] !== t) {
    t13 = t("all-filters");
    $[47] = t;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  let t14;
  if ($[49] !== t13) {
    t14 = <DropdownMenuRadioItem variant="circular" value={ALL_FILTERS_VALUE} onSelect={_temp}>{t13}</DropdownMenuRadioItem>;
    $[49] = t13;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== t11 || $[52] !== t12 || $[53] !== t14) {
    t15 = <DropdownMenuRadioGroup value={t11} onValueChange={t12}>{t14}</DropdownMenuRadioGroup>;
    $[51] = t11;
    $[52] = t12;
    $[53] = t14;
    $[54] = t15;
  } else {
    t15 = $[54];
  }
  let t16;
  if ($[55] !== filterType || $[56] !== options || $[57] !== selectedFilters || $[58] !== t || $[59] !== updateFilters) {
    let t17;
    if ($[61] !== filterType || $[62] !== options.length || $[63] !== selectedFilters || $[64] !== t || $[65] !== updateFilters) {
      t17 = option_0 => {
        const checked = selectedFilters.includes(option_0);
        return <DropdownMenuCheckboxItem key={option_0} checked={checked} onCheckedChange={updateFilters({
          type: filterType,
          value: option_0,
          maxOptionsCount: options.length
        })} onSelect={_temp2}>{t(FILTER_OPTIONS_TRANSLATION_MAPPING[option_0 as FILTER_OPTIONS])}</DropdownMenuCheckboxItem>;
      };
      $[61] = filterType;
      $[62] = options.length;
      $[63] = selectedFilters;
      $[64] = t;
      $[65] = updateFilters;
      $[66] = t17;
    } else {
      t17 = $[66];
    }
    t16 = options.map(t17);
    $[55] = filterType;
    $[56] = options;
    $[57] = selectedFilters;
    $[58] = t;
    $[59] = updateFilters;
    $[60] = t16;
  } else {
    t16 = $[60];
  }
  let t17;
  if ($[67] !== t) {
    t17 = t("apply-changes");
    $[67] = t;
    $[68] = t17;
  } else {
    t17 = $[68];
  }
  let t18;
  if ($[69] !== handleClick || $[70] !== t17) {
    t18 = <DropdownMenuItem asChild={true}><Button onClick={handleClick} className="w-full cursor-pointer rounded-none">{t17}</Button></DropdownMenuItem>;
    $[69] = handleClick;
    $[70] = t17;
    $[71] = t18;
  } else {
    t18 = $[71];
  }
  let t19;
  if ($[72] !== t15 || $[73] !== t16 || $[74] !== t18) {
    t19 = <DropdownMenuPortal><DropdownMenuContent align="start" className="min-w-(--radix-dropdown-menu-trigger-width) p-0">{t15}{t16}{t18}</DropdownMenuContent></DropdownMenuPortal>;
    $[72] = t15;
    $[73] = t16;
    $[74] = t18;
    $[75] = t19;
  } else {
    t19 = $[75];
  }
  let t20;
  if ($[76] !== T2 || $[77] !== t10 || $[78] !== t19 || $[79] !== t7 || $[80] !== t8) {
    t20 = <T2 open={t7} onOpenChange={t8}>{t10}{t19}</T2>;
    $[76] = T2;
    $[77] = t10;
    $[78] = t19;
    $[79] = t7;
    $[80] = t8;
    $[81] = t20;
  } else {
    t20 = $[81];
  }
  return t20;
};
export default FilterDropdown;
function _temp(event) {
  return event.preventDefault();
}
function _temp2(event_0) {
  return event_0.preventDefault();
}